module.exports = __webpack_public_path__ + "static/media/kulatak.d48dd223.png";